// ----------------------------------------------------------------------

function path(root: string, sublink: string) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = '/auth';
const ROOTS_DASHBOARD = '';
const ROOT_REPORTS = '/reports';
const ROOT_TENANTS = '/tenants';
const ROOTS_EMAIL_RECIPIENTS = '/email-recipients';

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, '/login'),
  loginUnprotected: path(ROOTS_AUTH, '/login-unprotected'),
  register: path(ROOTS_AUTH, '/register'),
  registerUnprotected: path(ROOTS_AUTH, '/register-unprotected'),
  resetPassword: path(ROOTS_AUTH, '/reset-password'),
  verify: path(ROOTS_AUTH, '/verify')
};

export const PATH_PAGE = {
  comingSoon: '/coming-soon',
  maintenance: '/maintenance',
  pricing: '/pricing',
  payment: '/payment',
  about: '/about-us',
  contact: '/contact-us',
  faqs: '/faqs',
  page404: '/404',
  page500: '/500',
  components: '/components',
  help: '/help'
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  general: {
    app: path(ROOTS_DASHBOARD, '/dashboard')
  },
};

export const PATH_REPORTS = {
  root: ROOT_REPORTS,
  general: {
    create: path(ROOT_REPORTS, '/create'),
    view: path(ROOT_REPORTS, '/view'),
    history: path(ROOT_REPORTS, '/history'),
    byClassification: (classification: string) => path(ROOT_REPORTS, `/${classification}`),
  },
};

export const PATH_TENANTS = {
  root: ROOT_TENANTS,
  general: {
    create: path(ROOT_TENANTS, '/create'),
    view: path(ROOT_TENANTS, '/view'),
    edit: (id: string | number) => path(ROOT_TENANTS, `/edit/${id}`),
  },
};

export const PATH_EMAIL_RECIPIENTS = {
  root: ROOTS_EMAIL_RECIPIENTS,
  general: {
    create: path(ROOTS_EMAIL_RECIPIENTS, '/create'),
    view: path(ROOTS_EMAIL_RECIPIENTS, '/view'),
  },
};

export const PATH_DOCS = 'https://docs-minimals.vercel.app/introduction';
